module.exports = __webpack_public_path__ + "img/竖向中线对齐2.a42156d4.svg";